import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

/**
 * A route component that handles role-based access control
 * - Owner: Can access everything
 * - Admin: Can access admin routes and customer routes
 * - Customer: Can only access customer routes
 */
const RoleBasedRoute = ({ children, allowedRoles = ['customer', 'admin', 'owner'] }) => {
  const { user, loading, userRole } = useAuth();

  if (loading) {
    return <div>Loading...</div>;
  }

  // Redirect to login if not authenticated
  if (!user) {
    return <Navigate to="/login" />;
  }

  // Owner has access to everything
  if (userRole === 'owner') {
    return children;
  }

  // Check if user's role is in the allowed roles
  if (allowedRoles.includes(userRole)) {
    return children;
  }

  // Redirect based on role
  if (userRole === 'admin') {
    return <Navigate to="/admin" />;
  } else {
    return <Navigate to="/dashboard" />;
  }
};

export default RoleBasedRoute; 